<template>
  <div>
    <PageBanner 
      title="About Us" 
      imageSrc="../assets/images/seedling-7494363_1280.jpg" 
      altText="A seedling growing in soil" 
    />
    <WhoWeAreSection />
    <!--
    <CeoSection />
    <KeyWorkerSection />
    -->
    <CallToActionSection />
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner.vue';
import WhoWeAreSection from '@/components/WhoWeAreSection.vue';
//import CeoSection from '@/components/CeoSection.vue';
//import KeyWorkerSection from '@/components/KeyWorkerSection.vue';
import CallToActionSection from "@/components/CallToActionSection.vue";


export default {
  name: "AboutView",
  components: {
    PageBanner,
    WhoWeAreSection,
    //CeoSection,
    //KeyWorkerSection,
    CallToActionSection
  },
};
</script>
